const IconTickLime = () => (
	<svg width='57' height='56' viewBox='-20 -20 100 100' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
		<defs>
			<path d='M53.667 25.9V28A25.593 25.593 0 0 1 28 53.667 25.593 25.593 0 0 1 2.333 28 25.593 25.593 0 0 1 28 2.333c3.5 0 7.233.7 10.5 2.334 1.167.466 1.633 1.866 1.167 3.033-.467 1.167-1.867 1.633-3.034 1.167C33.833 7.7 31.033 7 28 7 16.333 7 7 16.333 7 28s9.333 21 21 21 21-9.333 21-21v-2.1c0-1.4.933-2.333 2.333-2.333 1.4 0 2.334.933 2.334 2.333zM55.3 5.367c-.933-.934-2.333-.934-3.267 0L28 29.4l-5.367-5.367c-.933-.933-2.333-.933-3.266 0-.934.934-.934 2.334 0 3.267l7 7c.466.467 1.166.7 1.633.7.467 0 1.167-.233 1.633-.7L55.3 8.633c.933-.933.933-2.333 0-3.266z' id='nmg2lf6b4a'/>
		</defs>
		<g transform='translate(.5)' fill='none' fillRule='evenodd'>
			<mask id='qhofazqk4b' fill='#fff'>
				<use xlinkHref='#nmg2lf6b4a'/>
			</mask>
			<use fill='#8DC53F' fillRule='nonzero' xlinkHref='#nmg2lf6b4a'/>
			<g mask='url(#qhofazqk4b)' fill='#8DC53F'>
				<path d='M0 0h56v56H0z'/>
			</g>
		</g>
	</svg>

);

export default IconTickLime;
